import { useLocation, useNavigate } from "react-router-dom";

import { entityPaths } from "routes/entity/paths";

/**
 * Opens the Entity form pages. The current location travels as `from`, so
 * Cancel and the back link return to where the user started.
 */
export const useEntityNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = { from: `${location.pathname}${location.search}` };

  return {
    openCreate: () => navigate(entityPaths.create(), { state }),
    openEdit: id => navigate(entityPaths.edit(id), { state }),
  };
};
